/**
 * Just view/template component, no model/data logic!
 */
import React from "react"
// import Layout from "./../../layout"
// import Img from 'gatsby-image'
// import Image from "../../image"
// import SEO from "./../../seo"

// s4n
// import GeneralUtils from './../../../utils/common'
import ProductCard from '../Shop/Product/card'
// import "./../../assets/sass/templates/node/_blog.scss"



const ComponentStateless = (props) => {
  const { data } = props;

  return (
    <React.Fragment>
      <div className="row product-list">
          {data.aDataCollectionTranslated.map(({ node }, index) => {

            // console.log(node)
            // console.log(JSON.stringify(node, undefined, 4))

            return (
                <div key={`product-index-card-${index}`} className={`d-flex col-lg-4 col-md-6 mb-4`}>
                    <ProductCard product={node} />
                </div>
            )
          })}
      </div>
    </React.Fragment>
  )
}

export default ComponentStateless


/*

{
    "id": "60ea8693-9aa3-524a-bed8-4f599e7ef23e",
    "drupal_id": "faed812d-6265-4c40-b9a5-57211187b560",
    "drupal_internal__product_id": 549,
    "internal": {
        "type": "commerce_product__default"
    },
    "langcode": "pl",
    "title": "___SOFT4NET_DO_NOT_DELETE",
    "path": {
        "pid": 1594,
        "alias": "/sklep/soft4netdonotdelete",
        "langcode": "pl"
    },
    "body": {
        "summary": "Krótki tekst z podsumowaniem. Krótki tekst z podsumowaniem. Krótki tekst z podsumowaniem."
    },
    "created": "2019-07-29T14:47:12+00:00",
    "relationships": {
        "bundle": "commerce_product__defaultRelationships",
        "variations": [
            {
                "variationId": 4,
                "sku": "Variation a",
                "title": "___SOFT4NET_DO_NOT_DELETE - miesiąc",
                "price": {
                    "number": "1.000000",
                    "currencyCode": "USD"
                },
                "relationships": {
                    "bundle": "commerce_product_variation__defaultRelationships",
                    "field_images": [
                        {
                            "localFile": {
                                "childImageSharp": {
                                    "fluid": {
                                        "base64": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAESElEQVQ4y01UeWwUZRydYiWQVEPUxsg/tnvNXt1j9iqlh7UWBGIrjRI1GlHQmGgbiQeVwM5u9+jes7uU2kNqPKIQYqNGVCRExGgtEY1Ul2qpxNY0aKNoQmkB25/vm93ZdJKX9773vd+bnWs5DsdPapGbVIlMcjm1WPKLSryBKxx/VOxbNVuxdyU4e7Fin6D4LHNOJZYwPY3ZXGGe+16dF99qfCU/qH3FoqlK7y3Tld7B3yu9WbYGz85UegleD/buVHJs5gxm5S6NL2+OaPzFovMq780TKnEP+OI1nUTgtwv+ocu6BP2pCdOkynsJmfCEyluuzI1oCj/ma41fbh9X+1bjbM//qBYvTGm7Kaf206/aMGH9euG2lAM9Y2pxbkobpSlthO3NnFX7OnHpq1nmK22+i/tG428a1fgnc7pu+pmPEfTiaY3v8jg0WC7cYU8ot8YIDI1qfNfH+Sid00VYZhIdDXLghLar/KS265/TfIS+0AXppNZ//JTWv+FzbdfZMYPE1gdZDpkbuWXHl1q/gL1PTmFmFLPQ/6JrLXeUD9R/xAeWjusjdFQXyCoD8MZGjGkCD7H1GY1Y+iEfCACblhd/rAv0H9OH6YQ+yuY3c4f1wUaA3jN007v6YB0LDfOBNfDGPjNnCSwXHtIH9x8zpWk4nxv4gA+sZD608Yg+RO8bYyzbxh00hOqHjGFigL6bhV4zhMqgx4YtPczLDBpCTx82S0wvsNybxijT8js5ZAjx0PPvmJPMu5/LmLprAcqaIgRuZCFwGZDrq0pS2tT9G/RCFplMHkvwrmdM4ZpClgfm+6tSbK+FC5ojtSFzhMJVUYKWC8E3AbmIJaH4S6E8/11Y/wdUF7I8cCVhlZjfwnVaonWvWGLEsNsSlQvhlUFf2GtNEvSc396D/egb0D6mwVcBuRA5HnpetGWY38o9Z401ANRhS1C7NVarPD3ovheE/fSi4wDzv2Pes9ZY50uOXkJ+AVq+5A5rrKods7vsaea3cNtt8XXA4lOODD1uj+8pvg9E3A5b/LEnbfFPt9vjFcx6whbvesbZS8hfhS8/FMzEdgpp2ilkmN/EPWRPrHlQSMw+4jpA24TEtQeExP42IbF2+btmdqXlTwo58VF3H4GvILcFiGwTkvSwq4d5s+jKf9v3OZINWxzJiRZ3L7V5Bgh6dpMjJcK/je23CclSxvB9Wz39bH8OuLTV00etnlfZ+jyy8jvMtTiS8tlrXdKqJmeqo9GZmtxQPUAbAejpBqfUfq8jJX92WPuaUQBeaq7uZzyDmd0NLkn+c2gVEiXKL1yhXF61SyqrcUkvg2dqawapYf0QQQ8W9oJ31b3F1n8h07XOJd2qzBU7mp0pmTc6UhzOVvxfFNzpciBkc6cXgEWLO7PC7k7vgncEuEPJ3YMZNru8i6t3pNkl57VT4nD2YrHZk1GbPBkJuN1UnSlV/PXIIKvcruID/B/3zzPW0Hs+nQAAAABJRU5ErkJggg==",
                                        "aspectRatio": 1,
                                        "src": "/static/9998e49b67a0a98fcc5c32392a3a2d46/6deac/logo.png",
                                        "srcSet": "/static/9998e49b67a0a98fcc5c32392a3a2d46/27e4e/logo.png 64w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/849c8/logo.png 128w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/6deac/logo.png 255w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/6aff3/logo.png 383w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/82675/logo.png 500w",
                                        "sizes": "(max-width: 255px) 100vw, 255px"
                                    }
                                }
                            }
                        },
                        {
                            "localFile": {
                                "childImageSharp": {
                                    "fluid": {
                                        "base64": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAESElEQVQ4y01UeWwUZRydYiWQVEPUxsg/tnvNXt1j9iqlh7UWBGIrjRI1GlHQmGgbiQeVwM5u9+jes7uU2kNqPKIQYqNGVCRExGgtEY1Ul2qpxNY0aKNoQmkB25/vm93ZdJKX9773vd+bnWs5DsdPapGbVIlMcjm1WPKLSryBKxx/VOxbNVuxdyU4e7Fin6D4LHNOJZYwPY3ZXGGe+16dF99qfCU/qH3FoqlK7y3Tld7B3yu9WbYGz85UegleD/buVHJs5gxm5S6NL2+OaPzFovMq780TKnEP+OI1nUTgtwv+ocu6BP2pCdOkynsJmfCEyluuzI1oCj/ma41fbh9X+1bjbM//qBYvTGm7Kaf206/aMGH9euG2lAM9Y2pxbkobpSlthO3NnFX7OnHpq1nmK22+i/tG428a1fgnc7pu+pmPEfTiaY3v8jg0WC7cYU8ot8YIDI1qfNfH+Sid00VYZhIdDXLghLar/KS265/TfIS+0AXppNZ//JTWv+FzbdfZMYPE1gdZDpkbuWXHl1q/gL1PTmFmFLPQ/6JrLXeUD9R/xAeWjusjdFQXyCoD8MZGjGkCD7H1GY1Y+iEfCACblhd/rAv0H9OH6YQ+yuY3c4f1wUaA3jN007v6YB0LDfOBNfDGPjNnCSwXHtIH9x8zpWk4nxv4gA+sZD608Yg+RO8bYyzbxh00hOqHjGFigL6bhV4zhMqgx4YtPczLDBpCTx82S0wvsNybxijT8js5ZAjx0PPvmJPMu5/LmLprAcqaIgRuZCFwGZDrq0pS2tT9G/RCFplMHkvwrmdM4ZpClgfm+6tSbK+FC5ojtSFzhMJVUYKWC8E3AbmIJaH4S6E8/11Y/wdUF7I8cCVhlZjfwnVaonWvWGLEsNsSlQvhlUFf2GtNEvSc396D/egb0D6mwVcBuRA5HnpetGWY38o9Z401ANRhS1C7NVarPD3ovheE/fSi4wDzv2Pes9ZY50uOXkJ+AVq+5A5rrKods7vsaea3cNtt8XXA4lOODD1uj+8pvg9E3A5b/LEnbfFPt9vjFcx6whbvesbZS8hfhS8/FMzEdgpp2ilkmN/EPWRPrHlQSMw+4jpA24TEtQeExP42IbF2+btmdqXlTwo58VF3H4GvILcFiGwTkvSwq4d5s+jKf9v3OZINWxzJiRZ3L7V5Bgh6dpMjJcK/je23CclSxvB9Wz39bH8OuLTV00etnlfZ+jyy8jvMtTiS8tlrXdKqJmeqo9GZmtxQPUAbAejpBqfUfq8jJX92WPuaUQBeaq7uZzyDmd0NLkn+c2gVEiXKL1yhXF61SyqrcUkvg2dqawapYf0QQQ8W9oJ31b3F1n8h07XOJd2qzBU7mp0pmTc6UhzOVvxfFNzpciBkc6cXgEWLO7PC7k7vgncEuEPJ3YMZNru8i6t3pNkl57VT4nD2YrHZk1GbPBkJuN1UnSlV/PXIIKvcruID/B/3zzPW0Hs+nQAAAABJRU5ErkJggg==",
                                        "aspectRatio": 1,
                                        "src": "/static/9998e49b67a0a98fcc5c32392a3a2d46/6deac/logo%2520copy.png",
                                        "srcSet": "/static/9998e49b67a0a98fcc5c32392a3a2d46/27e4e/logo%2520copy.png 64w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/849c8/logo%2520copy.png 128w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/6deac/logo%2520copy.png 255w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/6aff3/logo%2520copy.png 383w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/82675/logo%2520copy.png 500w",
                                        "sizes": "(max-width: 255px) 100vw, 255px"
                                    }
                                }
                            }
                        }
                    ]
                }
            },
            {
                "variationId": 183,
                "sku": "Variation b",
                "title": "___SOFT4NET_DO_NOT_DELETE - 3 miesiące",
                "price": {
                    "number": "2.000000",
                    "currencyCode": "USD"
                },
                "relationships": {
                    "bundle": "commerce_product_variation__defaultRelationships",
                    "field_images": []
                }
            },
            {
                "variationId": 184,
                "sku": "Variation c",
                "title": "___SOFT4NET_DO_NOT_DELETE - 6 miesięcy",
                "price": {
                    "number": "3.000000",
                    "currencyCode": "USD"
                },
                "relationships": {
                    "bundle": "commerce_product_variation__defaultRelationships",
                    "field_images": [
                        {
                            "localFile": {
                                "childImageSharp": {
                                    "fluid": {
                                        "base64": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsSAAALEgHS3X78AAAESElEQVQ4y01UeWwUZRydYiWQVEPUxsg/tnvNXt1j9iqlh7UWBGIrjRI1GlHQmGgbiQeVwM5u9+jes7uU2kNqPKIQYqNGVCRExGgtEY1Ul2qpxNY0aKNoQmkB25/vm93ZdJKX9773vd+bnWs5DsdPapGbVIlMcjm1WPKLSryBKxx/VOxbNVuxdyU4e7Fin6D4LHNOJZYwPY3ZXGGe+16dF99qfCU/qH3FoqlK7y3Tld7B3yu9WbYGz85UegleD/buVHJs5gxm5S6NL2+OaPzFovMq780TKnEP+OI1nUTgtwv+ocu6BP2pCdOkynsJmfCEyluuzI1oCj/ma41fbh9X+1bjbM//qBYvTGm7Kaf206/aMGH9euG2lAM9Y2pxbkobpSlthO3NnFX7OnHpq1nmK22+i/tG428a1fgnc7pu+pmPEfTiaY3v8jg0WC7cYU8ot8YIDI1qfNfH+Sid00VYZhIdDXLghLar/KS265/TfIS+0AXppNZ//JTWv+FzbdfZMYPE1gdZDpkbuWXHl1q/gL1PTmFmFLPQ/6JrLXeUD9R/xAeWjusjdFQXyCoD8MZGjGkCD7H1GY1Y+iEfCACblhd/rAv0H9OH6YQ+yuY3c4f1wUaA3jN007v6YB0LDfOBNfDGPjNnCSwXHtIH9x8zpWk4nxv4gA+sZD608Yg+RO8bYyzbxh00hOqHjGFigL6bhV4zhMqgx4YtPczLDBpCTx82S0wvsNybxijT8js5ZAjx0PPvmJPMu5/LmLprAcqaIgRuZCFwGZDrq0pS2tT9G/RCFplMHkvwrmdM4ZpClgfm+6tSbK+FC5ojtSFzhMJVUYKWC8E3AbmIJaH4S6E8/11Y/wdUF7I8cCVhlZjfwnVaonWvWGLEsNsSlQvhlUFf2GtNEvSc396D/egb0D6mwVcBuRA5HnpetGWY38o9Z401ANRhS1C7NVarPD3ovheE/fSi4wDzv2Pes9ZY50uOXkJ+AVq+5A5rrKods7vsaea3cNtt8XXA4lOODD1uj+8pvg9E3A5b/LEnbfFPt9vjFcx6whbvesbZS8hfhS8/FMzEdgpp2ilkmN/EPWRPrHlQSMw+4jpA24TEtQeExP42IbF2+btmdqXlTwo58VF3H4GvILcFiGwTkvSwq4d5s+jKf9v3OZINWxzJiRZ3L7V5Bgh6dpMjJcK/je23CclSxvB9Wz39bH8OuLTV00etnlfZ+jyy8jvMtTiS8tlrXdKqJmeqo9GZmtxQPUAbAejpBqfUfq8jJX92WPuaUQBeaq7uZzyDmd0NLkn+c2gVEiXKL1yhXF61SyqrcUkvg2dqawapYf0QQQ8W9oJ31b3F1n8h07XOJd2qzBU7mp0pmTc6UhzOVvxfFNzpciBkc6cXgEWLO7PC7k7vgncEuEPJ3YMZNru8i6t3pNkl57VT4nD2YrHZk1GbPBkJuN1UnSlV/PXIIKvcruID/B/3zzPW0Hs+nQAAAABJRU5ErkJggg==",
                                        "aspectRatio": 1,
                                        "src": "/static/9998e49b67a0a98fcc5c32392a3a2d46/6deac/logo%2520copy%25202.png",
                                        "srcSet": "/static/9998e49b67a0a98fcc5c32392a3a2d46/27e4e/logo%2520copy%25202.png 64w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/849c8/logo%2520copy%25202.png 128w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/6deac/logo%2520copy%25202.png 255w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/6aff3/logo%2520copy%25202.png 383w,\n/static/9998e49b67a0a98fcc5c32392a3a2d46/82675/logo%2520copy%25202.png 500w",
                                        "sizes": "(max-width: 255px) 100vw, 255px"
                                    }
                                }
                            }
                        }
                    ]
                }
            }
        ],
        "field_category": [
            {
                "name": "Badania kompetencji"
            },
            {
                "name": "E-learning - pojedyncze lekcje"
            }
        ]
    }
}

*/